module.exports = __webpack_public_path__ + "static/media/whatsappIcon.f630fec8.svg";